import { render, staticRenderFns } from "./SickLeaveFinalForm.vue?vue&type=template&id=37968dfc"
import script from "./SickLeaveFinalForm.vue?vue&type=script&lang=js"
export * from "./SickLeaveFinalForm.vue?vue&type=script&lang=js"
import style0 from "./SickLeaveFinalForm.vue?vue&type=style&index=0&id=37968dfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports